import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import { authApi } from './api/authApi';
import { clientsApi } from './api/clientsApi';
import { userApi } from './api/userApi';
import { providersApi } from './api/providersApi';
import { endpointsApi } from './api/endpointsApi';
import { organizationsApi } from './api/organizationsApi';
import { businessSystemsApi } from './api/businessSystemsApi';
import { logsApi } from './api/logsApi';
import { certificatesApi } from './api/certificatesApi';
import { managementClientsApi } from './api/managementClientsApi';
import { logoutMiddleware } from './middleware/logoutMiddleware';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    [authApi.reducerPath]: authApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [providersApi.reducerPath]: providersApi.reducer,
    [endpointsApi.reducerPath]: endpointsApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [businessSystemsApi.reducerPath]: businessSystemsApi.reducer,
    [logsApi.reducerPath]: logsApi.reducer,
    [certificatesApi.reducerPath]: certificatesApi.reducer,
    [managementClientsApi.reducerPath]: managementClientsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    })
      .concat(logoutMiddleware)  // Add logout middleware FIRST to run before API middleware
      .concat(authApi.middleware)
      .concat(clientsApi.middleware)
      .concat(userApi.middleware)
      .concat(providersApi.middleware)
      .concat(endpointsApi.middleware)
      .concat(organizationsApi.middleware)
      .concat(businessSystemsApi.middleware)
      .concat(logsApi.middleware)
      .concat(certificatesApi.middleware)
      .concat(managementClientsApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;